<div class="brn-card" [ngClass]="[colorScheme, shadowClass]">
  <ng-content></ng-content>
</div>
